module.exports = __webpack_public_path__ + "img/129.9f669f47.gif";